import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BASEURL from "../../../Utils/Baseurl";
import MaterialSelect from "../../../../components/MasterSelect";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useUserDetails } from "../../../../context/auth";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/loading";
const AddDesignation = () => {
  const navigate = useNavigate();
    const { circleLoading, setCirleLoading } = useLoading();
  
  const { display, setdisplay, AccessData, update, setupdate } =
    useUserDetails();

  const [id, setId] = useState(null);
  const [viewData, setViewData] = useState("");
  const [depdisplay, setdepdisplay] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [togglePage, setTogglePage] = useState({
    view: true,
    edit: true,
  });

  const [designationData, setDesignationData] = useState({
    departmentName: "",
    designationName: "",
    departmentNameStatus: "unchecked",
    designationNameStatus: "unchecked",
  });

  const [resource, setResource] = useState({
    departmentName: [],
  });

  const [originalDesigntionData, setOriginalDesignationData] = useState({
    departmentName: "",
    designationName: "",
    departmentNameStatus: "",
    designationNameStatus: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    onDepartmentSubmit();
    if (id) {
      getInitData(id);
    }
  }, []);

  useEffect(() => {
    onfilterData();
  }, [viewData]);

  const getInitData = async (id) => {
    const query = `query get_designation($id:String){
  getDesignationById(id:$id)
{
  id
  designation
  departmentName
}}

              `;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responsesss:", response);
      // Extract Leavetype data from the response
      const departmentRowdata = response.data.data.getDesignationById;
      const departmentNameData =
        response.data.data.getDesignationById?.departmentName;
      setViewData(departmentNameData);
      setdepdisplay(true);
      setDesignationData({
        departmentName: {
          value: departmentRowdata.departmentName,
          label: departmentRowdata.departmentName,
        },
        designationName: departmentRowdata.designation,
        departmentNameStatus: departmentRowdata?.departmentName ? "success" : "unchecked",
        designationNameStatus: departmentRowdata.designation ? "success" : "unchecked"
      });

      setOriginalDesignationData({
        departmentName: {
          value: departmentRowdata.departmentName,
          label: departmentRowdata.departmentName,
        },
        designationName: departmentRowdata.designation,
       
      });

      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onEditDesignationSubmit = async () => {
    setCirleLoading(true)
    const query = `  mutation ($id: String!, $designation:String!, $departmentName: String!){
    EditDesignation(id:$id, designation:$designation, departmentName:$departmentName){
      designationeditdetails{
        designation
        departmentName
        id
      }
    }
  }
`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id,
            designation: designationData.designationName,
            departmentName: designationData.departmentName.label,
          },
        }),
      });

      console.log("response:", response.data);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setCirleLoading(false)
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Designation Updated Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/designation");
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false)
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  console.log(designationData,"designationData");
  

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteDesignationSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteDesignationSubmit = async () => {
    const query = `
            mutation DeleteDesignation($id: String!) {
                deleteDesignation(id: $id) {
                    success
                    message
                }
            }
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.deleteDesignation.success) {
        console.log("Designation deleted successfully!");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Designation deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/designation");
      } else {
        console.log(
          "Error deleting designation:",
          response.data.data.deleteDesignation.message
        );
      }
    } catch (error) {
      console.error("An error occurred while deleting the designation:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onDepartmentSubmit = async () => {
    const query = `query {
            allDepartment {
                id
                departmentName
                departmentCode
            }
        }`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // Extract department data from the response
      const departmentListdata = response.data.data.allDepartment;
      setResource({
        ...resource,
        departmentName: departmentListdata,
      });
      setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response departmentListdata:", departmentListdata);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const onDesignationSubmit = async () => {
    setCirleLoading(true)
    const query = `mutation Designations(
                $designation: String!
                 $departmentName: String!
              ) {
            AddDesignation(designation: $designation, departmentName: $departmentName) {
          designationdetails {
      id
      designation
      departmentName
      lastUpdate
            }
            }
           }`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            designation: designationData.designationName,
            departmentName: designationData.departmentName.label,
          },
        }),
      });

      console.log("response:", response.data);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setCirleLoading(false)
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Designation Submitted Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/designation");
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false)
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleDesignationDatachange = (event, selectEvent) => {
    console.log("selectEvent:", selectEvent, event?.label);
    let designationState = { ...designationData };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "departmentName") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          designationState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          designationState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      designationState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "designationName":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              designationState[event.target.name + "Status"] = "success";
            } else {
              designationState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        designationState[event.target.name] = event.target.value;
      }
    }
    setDesignationData(designationState);
  };

  const onfilterData = () => {
    const filterDepartment = resource.departmentName.filter(
      (department) => department.departmentName == viewData
    );
    console.log(
      "filterDepartment:",
      viewData,
      resource.departmentName,
      filterDepartment
    );
    console.log("display:", display);
  };
  const AddDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Discards your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardDesignation();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onDiscardDesignation = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

    setDesignationData({
        departmentName: originalDesigntionData.departmentName,
        designationName: originalDesigntionData.designationName,
    })

    setupdate(false);
    setdepdisplay(true);
  };

  const handleAddDesignation = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDesignationSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
    setupdate(true);
    setdepdisplay(false);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      designationData.departmentNameStatus === "success" &&
      designationData.designationNameStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      designationData.departmentName ===
        originalDesigntionData.departmentName &&
      designationData.designationName === originalDesigntionData.designationName
    ) {
      allowSubmit = false;
    } else if (
      designationData.departmentName !== originalDesigntionData.departmentName
    ) {
      if (designationData.departmentNameStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (
      designationData.designationName !== originalDesigntionData.designationName
    ) {
      if (designationData.designationNameStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/designation");
  };


  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "EditDesignation" && item.can_access
                ) &&
                (togglePage.edit || togglePage.view ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                      {togglePage.view ? "View Designation Details" : "Edit Designation Details"}

                   
                      </MaterialTypography>
                    </Stack>

                    {display && (
                      <>
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                          {/* Uncomment this block to add delete functionality */}

                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      </>
                    )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Designation Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                ))}
            </>
          }
        />
        <CardContent sx={{ minHeight: "55vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="departmentName"
                  value={designationData.departmentName}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleDesignationDatachange} //selectedValue, event
                  options={resource.departmentName.map((value) => {
                    return {
                      value: value.id,
                      label: value.departmentName,
                    };
                  })}
                  error={
                    designationData.departmentNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    designationData.departmentNameStatus === "success"
                      ? true
                      : false
                  }
                  // isClearable
                  isDisabled={depdisplay}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Designation Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                {display ? (
                  <MaterialInput
                    name="designationName"
                    value={designationData.designationName}
                    onChange={handleDesignationDatachange}
                    error={designationData.designationNameStatus === "error"}
                    success={
                      designationData.designationNameStatus === "success"
                    }
                    disabled={!update}
                  />
                ) : (
                  <MaterialInput
                    name="designationName"
                    value={designationData.designationName}
                    onChange={handleDesignationDatachange}
                    error={designationData.designationNameStatus === "error"}
                    success={
                      designationData.designationNameStatus === "success"
                    }
                  />
                )}
                {designationData.designationNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Designation Name should be a maximum of 40 characters long
                      and can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
         

          {update && (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={AddDiscard}
              >
                Discard
              </MaterialButton>

              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={!checkFields()}
                onClick={onEditDesignationSubmit}
              >
                Update
              </MaterialButton>
            </>
          )}

          {!display && (
            <>
           <MaterialButton
                              sx={{ m: 2 }}
                              variant="gradient"
                              color="dark"
                              onClick={handlecancel}
                            >
                              Cancel
                            </MaterialButton>
                            <MaterialButton
                            sx={{ m: 4, marginLeft: "4px" }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddDesignation}
            >
              Submit
            </MaterialButton>
            </>
          )}
        </MaterialBox>
        {
          <MaterialSnackbar
            color="success"
            icon={<NotificationsIcon />}
            title="Message"
            content="You have been submitted successfully"
            open={snackBar.Success}
            close={() =>
              setSnackBar({
                success: false,
              })
            }
          />
        }
      </Card>
    </DashboardLayout>
  );
};

export default AddDesignation;
